// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2u3zC","info":"PatientInfo_info__2cFSS"};